export function getValidSelectValue(
    value: number | string,
    options: Option[],
    defaultValue: number | string
) {
    return options.some((opt) => Number(opt.id) === Number(value)) ? value : defaultValue;
}
export interface Option {
    id: number | string;
    name: string;
}

export function getZeroOption(text: string): Option {
    return { id: 0, name: text };
}
